/* BHBY on-site CRO survey. Plain ES2017, no deps. 2026-09-06.
 * Config comes from #bhby-survey data-* attrs (see snippets/bhby-survey.liquid).
 * See shopify/data/cro/THEME_WIRING.md for wiring + survey_test.html for a
 * local harness.
 */
(function () {
  'use strict';
  var root = document.getElementById('bhby-survey');
  if (!root) return;

  var SEEN_KEY = 'bhby_survey_seen';
  var SHORT_D = 30, LONG_D = 90, DAY = 86400000;
  var state = { step: 1, score: null, shown: false, trigger: null };
  var fired = false;

  // ---- cookies ----
  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(n, v, days) {
    try {
      var d = new Date(); d.setTime(d.getTime() + days * DAY);
      document.cookie = n + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }
  function randomHex16() {
    var b = new Uint8Array(8);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(b);
    else for (var i = 0; i < 8; i++) b[i] = Math.floor(Math.random() * 256);
    var out = '';
    for (var j = 0; j < b.length; j++) out += ('0' + b[j].toString(16)).slice(-2);
    return out;
  }
  function sid() {
    var s = getCookie('bhby_sid');
    if (!s) { s = randomHex16(); setCookie('bhby_sid', s, 365); }
    return s;
  }

  // ---- frequency cap (localStorage) ----
  function readSeen() {
    try { var r = localStorage.getItem(SEEN_KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; }
  }
  function writeSeen(s) { try { localStorage.setItem(SEEN_KEY, JSON.stringify(s)); } catch (e) {} }
  function withinCooldown() {
    var s = readSeen();
    if (!s || !s.ts) return false;
    var days = (s.state === 'submitted' || s.state === 'dismissed_twice') ? LONG_D : SHORT_D;
    return (Date.now() - s.ts) < days * DAY;
  }
  function markSeen(kind) {
    var prev = readSeen();
    var dc = (prev && prev.dismissCount) || 0;
    if (kind === 'dismissed') dc += 1;
    writeSeen({ ts: Date.now(), state: (kind === 'dismissed' && dc >= 2) ? 'dismissed_twice' : kind, dismissCount: dc });
  }

  // ---- consent gate ----
  function consentAllowed() {
    try {
      return !!(window.Shopify && window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  // ---- buy-box DOM readers (sections/bhby-buybox.liquid classes) ----
  function packAndMode() {
    var tier = document.querySelector('.bhby-tier.bhby-selected');
    var mode = document.querySelector('.bhby-pmode.bhby-selected');
    return {
      pack_bottles: tier ? tier.getAttribute('data-bottles') : null,
      purchase_mode: mode ? mode.getAttribute('data-mode') : null
    };
  }
  function variantId() {
    var tier = document.querySelector('.bhby-tier.bhby-selected');
    if (tier && tier.getAttribute('data-variant-id')) return tier.getAttribute('data-variant-id');
    var input = document.querySelector('[data-bhby-id-input]') || document.querySelector('[name="id"]');
    return input ? input.value : null;
  }
  // Real class from assets/bhby-pdp.js: body.bhby-modal-open while the
  // [data-bhby-clarity] subscription clarity modal is visible.
  function subModalOpen() { return document.body.classList.contains('bhby-modal-open'); }

  // ---- misc context ----
  function utm() {
    var p = new URLSearchParams(location.search);
    return { utm_source: p.get('utm_source'), utm_medium: p.get('utm_medium'), utm_campaign: p.get('utm_campaign'), utm_content: p.get('utm_content'), utm_term: p.get('utm_term') };
  }
  function cookieSeg(name) { var v = getCookie(name); return v ? (v.split('|')[0] || null) : null; }
  function deviceType() {
    var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
    return (window.innerWidth >= 1024 && fine) ? 'desktop' : 'mobile';
  }
  function cartSnapshot(timeoutMs) {
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () { if (!done) { done = true; resolve({ cart_token: null, cart_item_count: null, cart_subtotal_cents: null }); } }, timeoutMs);
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        if (done) return; done = true; clearTimeout(timer);
        resolve({ cart_token: c.token || null, cart_item_count: typeof c.item_count === 'number' ? c.item_count : null, cart_subtotal_cents: typeof c.total_price === 'number' ? c.total_price : null });
      }).catch(function () { if (!done) { done = true; clearTimeout(timer); resolve({ cart_token: null, cart_item_count: null, cart_subtotal_cents: null }); } });
    });
  }

  // ---- open / close / steps ----
  function showRoot() { root.removeAttribute('hidden'); state.shown = true; }
  function hideRoot() { root.setAttribute('hidden', ''); }
  function goStep(n) {
    state.step = n;
    var steps = root.querySelectorAll('.bhby-survey__step');
    for (var i = 0; i < steps.length; i++) {
      if (parseInt(steps[i].getAttribute('data-step'), 10) === n) steps[i].removeAttribute('hidden');
      else steps[i].setAttribute('hidden', '');
    }
  }
  function resetSelection() {
    state.score = null; selectedReason = null;
    var rb = root.querySelectorAll('.bhby-survey__reason');
    for (var i = 0; i < rb.length; i++) rb[i].removeAttribute('aria-pressed');
    var ta = root.querySelector('[data-bhby-survey-text]');
    if (ta) ta.value = '';
  }
  function open() { if (subModalOpen()) return; goStep(1); showRoot(); }
  function close(reason) { hideRoot(); if (reason === 'dismiss') markSeen('dismissed'); resetSelection(); }
  function reset() { try { localStorage.removeItem(SEEN_KEY); } catch (e) {} resetSelection(); goStep(1); }

  // ---- submit ----
  function buildPayload(score, reasonCode, freeText, trigger) {
    var pm = packAndMode();
    return cartSnapshot(2000).then(function (cart) {
      return Object.assign({
        ts: new Date().toISOString(),
        page_path: location.pathname,
        template: root.getAttribute('data-template') || null,
        template_suffix: root.getAttribute('data-template-suffix') || null,
        product_handle: root.getAttribute('data-product-handle') || null,
        variant_id: variantId(),
        pack_bottles: pm.pack_bottles,
        purchase_mode: pm.purchase_mode,
        device: deviceType(),
        viewport: window.innerWidth + 'x' + window.innerHeight,
        ab_variant: (document.documentElement.dataset && document.documentElement.dataset.ab) || null,
        bhby_sid: sid(),
        referrer: document.referrer || null,
        score: score,
        reason_code: reasonCode || null,
        free_text: freeText ? String(freeText).trim().slice(0, 300) : null,
        clarity_session_id: cookieSeg('_clsk'),
        clarity_click_id: cookieSeg('_clck'),
        trigger: trigger || null
      }, utm(), cart);
    });
  }
  function send(payload) {
    var endpoint = root.getAttribute('data-endpoint');
    if (!endpoint) return;
    try {
      fetch(endpoint, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(payload) }).catch(function () {});
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('bhby_survey_submitted', { score: payload.score, reason_code: payload.reason_code, template: payload.template });
      }
    } catch (e) {}
  }

  // ---- wire up markup ----
  var selectedReason = null;
  root.querySelector('.bhby-survey__close').addEventListener('click', function () { close('dismiss'); });

  var faces = root.querySelectorAll('.bhby-survey__face');
  for (var f = 0; f < faces.length; f++) {
    faces[f].addEventListener('click', function (e) {
      state.score = parseInt(e.currentTarget.getAttribute('data-score'), 10);
      goStep(2);
    });
  }
  var reasons = root.querySelectorAll('.bhby-survey__reason');
  for (var r = 0; r < reasons.length; r++) {
    reasons[r].addEventListener('click', function (e) {
      for (var i = 0; i < reasons.length; i++) reasons[i].removeAttribute('aria-pressed');
      e.currentTarget.setAttribute('aria-pressed', 'true');
      selectedReason = e.currentTarget.getAttribute('data-reason');
    });
  }
  root.querySelector('[data-bhby-survey-send]').addEventListener('click', function () {
    var ta = root.querySelector('[data-bhby-survey-text]');
    buildPayload(state.score, selectedReason, ta ? ta.value : '', state.trigger).then(send);
    markSeen('submitted');
    goStep(3);
    setTimeout(close, 2500);
  });
  root.querySelector('[data-bhby-survey-skip]').addEventListener('click', function () {
    buildPayload(state.score, null, null, state.trigger).then(send);
    close('dismiss');
  });

  // ---- triggers ----
  function fireOnce(trigger) {
    if (fired || state.shown) return;
    if (withinCooldown() || !consentAllowed() || subModalOpen()) return;
    fired = true; state.trigger = trigger; open();
  }
  function setupTriggers() {
    var template = root.getAttribute('data-template');
    if (template === 'product') {
      var dwellTimer = setTimeout(function () { fireOnce('dwell'); }, 45000);
      window.addEventListener('scroll', function onScroll() {
        var doc = document.documentElement;
        var depth = doc.scrollHeight > 0 ? (window.scrollY + window.innerHeight) / doc.scrollHeight : 0;
        if (depth >= 0.6) { clearTimeout(dwellTimer); fireOnce('scroll'); window.removeEventListener('scroll', onScroll); }
      }, { passive: true });
    }
    if (template === 'cart') setTimeout(function () { fireOnce('cart'); }, 20000);

    // Cart-drawer open: apps:product-added-to-cart is the theme's own hook
    // (bhby-pdp.js performAdd() dispatches it on success; quick-cart.liquid
    // opens the drawer on the same event). No [data-action="open-drawer"]
    // element exists in this theme, so this is the real signal to use.
    document.addEventListener('apps:product-added-to-cart', function () {
      setTimeout(function () { fireOnce('cart'); }, 20000);
    });

    // Exit intent: desktop only, once.
    if (window.matchMedia('(pointer:fine)').matches && window.innerWidth >= 1024) {
      var bound = false;
      document.addEventListener('mouseleave', function onLeave(e) {
        if (bound || e.clientY > 0) return;
        bound = true; document.removeEventListener('mouseleave', onLeave);
        fireOnce('exit');
      });
    }
  }

  // consentAllowed() is read fresh at fire time, so no caching needed here.
  document.addEventListener('visitorConsentCollected', function () {});

  // ---- boot ----
  if (new URLSearchParams(location.search).get('bhby_survey') === '1') {
    if (consentAllowed()) { state.trigger = 'force'; open(); }
  } else if (consentAllowed() && !withinCooldown()) {
    setupTriggers();
  }

  window.BHBYSurvey = { open: open, close: close, reset: reset };
})();
